import * as React from 'react';
import { FieldHookConfig, useField } from 'formik';
import { SelectionControlsGroupProps } from 'omakase/SelectionControls/SelectionControlsGroupCore';
import { checkFormHasError } from '@tock/shared/ui/forms/formHelpers';
import CheckboxGroup from 'omakase/SelectionControls/CheckboxGroup';

/**
 * (Formik) Implementation of grouping behaviors for checkboxes.
 * Use FormCheckbox components as children.
 */
const FormCheckboxGroup: React.FunctionComponent<SelectionControlsGroupProps> = ({
  helperText,
  label,
  disabled,
  children,
  ...rest
}) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const fieldAndMeta = useField(rest as FieldHookConfig<any>);
  const meta = fieldAndMeta[1];
  const hasError = checkFormHasError(meta);

  return (
    <CheckboxGroup
      error={hasError}
      errorText={meta.error}
      helperText={helperText}
      label={label}
      disabled={disabled}
      {...rest}
    >
      {React.Children.map(children, (child) => {
        return React.cloneElement(child as React.ReactElement, { group: true, disabled });
      })}
    </CheckboxGroup>
  );
};

export default FormCheckboxGroup;
